import { render } from "./TheDeviceGenerals.vue?vue&type=template&id=22913e5d"
import script from "./TheDeviceGenerals.vue?vue&type=script&lang=js"
export * from "./TheDeviceGenerals.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__